import { httpGetRequest } from "clients/phronesisClient"
import {
	BenchmarkGrowthTimelineResponse,
	BenchmarkResponse,
	BenchmarkSummaryResponse,
	BenchmarkTimelineResponse,
	RequestParameters,
} from "./interfaces"
import { getEndpoints, VERSIONS } from "constants/endpoint"
import { FEATURE_FLAG_BENCHMARK_V2 } from "./constants"
import { MetricName } from "./components/MetricsSelect/interfaces"
import { disabledMetric } from "components/Shared/Filters/modules/Segmentation/constants"
import { CUSTOMER_TYPE } from "components/Shared/GlobalFilter/constants"
import { concatValues } from "helpers/service"

const NUMBER_OF_RETRIES = 0
const getVersion = (filters: RequestParameters) =>
	FEATURE_FLAG_BENCHMARK_V2[filters.selectedMetric as MetricName]
		? VERSIONS.v2
		: VERSIONS.v1

const prepareFilters = (filters: RequestParameters) => {
	let filters_ = filters
	if (disabledMetric[filters.selectedMetric as MetricName]) {
		filters_ = { ...filters, [CUSTOMER_TYPE]: "" }
	}

	const parsedFilters = Object.entries(filters_).reduce(
		(currentValue, [key, value]) => {
			if (typeof value === "object") {
				return {
					...currentValue,
					[key]: concatValues(value),
				}
			}
			return {
				...currentValue,
				[key]: value,
			}
		},
		{}
	)
	return { ...parsedFilters }
}

export const getBenchmarkMetrics = async (
	filters: RequestParameters
): Promise<BenchmarkResponse> => {
	const version = getVersion(filters)
	const filters_ = prepareFilters(filters)
	return httpGetRequest<BenchmarkResponse>(
		getEndpoints(version).transactional.benchmark.breakdown,
		filters_,
		undefined,
		undefined,
		undefined,
		NUMBER_OF_RETRIES
	)
}

export const getBenchmarkSalesTimeline = async (
	filters: RequestParameters
): Promise<BenchmarkTimelineResponse> => {
	const filters_ = prepareFilters(filters)
	return httpGetRequest<BenchmarkTimelineResponse>(
		getEndpoints(VERSIONS.v1).transactional.benchmark.timeline.metric,
		filters_,
		undefined,
		undefined,
		undefined,
		NUMBER_OF_RETRIES
	)
}

export const getBenchmarkGrowthTimeline = async (
	filters: RequestParameters
): Promise<BenchmarkGrowthTimelineResponse> => {
	const filters_ = prepareFilters(filters)
	return httpGetRequest<BenchmarkGrowthTimelineResponse>(
		getEndpoints(VERSIONS.v1).transactional.benchmark.timeline.growth +
			`/${filters.selectedMetric}`,
		filters_,
		undefined,
		undefined,
		undefined,
		NUMBER_OF_RETRIES
	)
}

export const getBenchmarkSummaryCards = async (
	filters: RequestParameters
): Promise<BenchmarkSummaryResponse> => {
	const filters_ = prepareFilters(filters)
	return httpGetRequest<BenchmarkSummaryResponse>(
		getEndpoints(VERSIONS.v1).transactional.benchmark.summary,
		filters_,
		undefined,
		undefined,
		undefined,
		NUMBER_OF_RETRIES
	)
}
